import AnionTestingPart from './AnionTestingPart';

export default function Part4Iodide() {
  return (
    <AnionTestingPart
      partNumber={4}
      anionSymbol="I-"
      anionName="Iodide"
      anionFormula="0.1 M NaI"
      anionColor="#FFF9C4"
      infoContent={{
        title: 'Iodide Solubility',
        content: 'Silver iodide forms a bright yellow precipitate. Note the color trend: AgCl (white) -> AgBr (cream) -> AgI (yellow). This relates to increasing halide size and polarizability.',
        equation: 'Ag+(aq) + I-(aq) -> AgI(s) [bright yellow]'
      }}
    />
  );
}
